import { Button } from "../../core/components/button";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import React from "react";
export default class CheckAppServerButton extends React.Component<any, any>{
    constructor(props) {
        super(props);
    }

    private handleClick = async (e) => {
        let result = await HTTPService.get<JsonResultClass>("MobileClient/TestConnection"
            + "?url=" + encodeURIComponent(this.props.entity.GeneralSettings.PhoenixServiceUrl)
            + "&userName=" + encodeURIComponent(this.props.entity.GeneralSettings.AppServerUser)
            + "&password=" + encodeURIComponent(this.props.entity.GeneralSettings.AppServerPassword));
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(result.Message);
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    render() {
        return <Button handleClick={this.handleClick} iconName={"badge-check"} title={Helper.getTranslation("WebSMS.GeneralSettings.CheckConnection")} />
    }
}